import { setArableEnvironment } from '@next/arable-lib/shared';
import { Environment } from './environment.model';

export { Environment } from './environment.model';

export const environment: Environment = {
  ...setArableEnvironment({
    APPLICATION_NAME: 'ArablePartnerHub',
    API_BASE_URL: 'https://arable-partner-hub.agrifirm.com',
    APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
    CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
    REDIRECT_URL: 'https://arable-partner-hub.agrifirm.com',
    SIGNUP_SIGNIN_POLICY: 'B2C_1A_EmployeeSignin',
    PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
    AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
    LOGIN_TYPE: 'redirect',
    APPLICATION_KEY: 'ArablePartnerHub',
    AUTHORIZED_BY: 'ArablePartnerHub|Intermediary|GlobalAdministrator',
    APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
    DEFAULT_LOCALE: 'nl-NL',
    LOCALES: 'nl-NL,en-US',
    PRODUCTION: 'true',
  }),
  CHAIN_PARTNER_DASHBOARD_WORKSPACE_ID: '6b92be3f-a6da-4e0d-9662-72aebd34fad7',
  CHAIN_PARTNER_DASHBOARD_REPORT_ID: '22e32204-6fdc-4c9d-af61-ec385f48697d',
};
